import { AnyAction } from "redux";

const INIT_STATE: string = "";

export default function subFamiliesGroupDesignation(
    state = INIT_STATE,
    action: AnyAction
): string | null {
    if (action.type === "SUBFAMILIES_GROUP_DESIGNATION") {
        return action.payload;
    } else {
        return state !== undefined ? state : null;
    }
}
